export enum messageTypesBase {
  email = 'email',
  sms = 'sms',
}
export const messageTypes = [messageTypesBase.email, messageTypesBase.sms]

export enum languagesBase {
  en = 'en',
  he = 'he',
  ru = 'ru',
}
export const languages = [languagesBase.en, languagesBase.he, languagesBase.ru]

export enum emailObjectsBase {
  subject = 'subject',
  body = 'body',
}

export const emailObjects = [emailObjectsBase.subject, emailObjectsBase.body]

export enum smsObjectsBase {
  message = 'message',
}

export const smsObjects = [smsObjectsBase.message]

export enum emailMessageTypesBase {
  passwordSetupSuccess = 'passwordSetupSuccess',
  passwordForgot = 'passwordForgot',
  passwordResetSuccess = 'passwordResetSuccess',
  registration = 'registration',
  loginMultiFactorCode = 'loginMultiFactorCode',
  usernameForgot = 'usernameForgot',
  loginFromNewDevice = 'loginFromNewDevice',
  specialist = 'specialist',
  zohoTemplate = 'zohoTemplate',
  specialistDiagnosisToCheck = 'specialistDiagnosisToCheck',
  interpreterExamToCheck = 'interpreterExamToCheck',
}

export const emailMessageTypes = [
  emailMessageTypesBase.passwordSetupSuccess,
  emailMessageTypesBase.passwordForgot,
  emailMessageTypesBase.passwordResetSuccess,
  emailMessageTypesBase.registration,
  emailMessageTypesBase.loginMultiFactorCode,
  emailMessageTypesBase.usernameForgot,
  emailMessageTypesBase.loginFromNewDevice,
  emailMessageTypesBase.specialist,
  emailMessageTypesBase.zohoTemplate,
  emailMessageTypesBase.specialistDiagnosisToCheck,
  emailMessageTypesBase.interpreterExamToCheck,
]

export enum smsMessageTypesBase {
  usernameApp = 'usernameApp',
  forgotPasswordWithCode = 'forgotPasswordWithCode',
  createAppointment = 'createAppointment',
  testReady = 'testReady',
  criticalCaseNotAnswerd = 'criticalCaseNotAnswerd',
  noCallCenterDoctorsInShift = 'noCallCenterDoctorsInShift',
  specialistDiagnosisToCheck = 'specialistDiagnosisToCheck',
  interpreterExamToCheck = 'interpreterExamToCheck',
}

export const smsMessageTypes = [
  smsMessageTypesBase.usernameApp,
  smsMessageTypesBase.forgotPasswordWithCode,
  smsMessageTypesBase.createAppointment,
  smsMessageTypesBase.testReady,
  smsMessageTypesBase.criticalCaseNotAnswerd,
  smsMessageTypesBase.noCallCenterDoctorsInShift,
  smsMessageTypesBase.specialistDiagnosisToCheck,
  smsMessageTypesBase.interpreterExamToCheck,
]

export interface Translation {
  [languagesBase.en]: string | null
  [languagesBase.he]: string | null
  [languagesBase.ru]: string | null
}

export interface Email {
  [emailObjectsBase.subject]: Translation
  [emailObjectsBase.body]: Translation
}

export interface Sms {
  [smsObjectsBase.message]: Translation
}

export default interface ConfigurationMessage {
  [messageTypesBase.email]: {
    [emailMessageTypesBase.passwordSetupSuccess]: Email
    [emailMessageTypesBase.passwordForgot]: Email
    [emailMessageTypesBase.passwordResetSuccess]: Email
    [emailMessageTypesBase.registration]: Email
    [emailMessageTypesBase.loginMultiFactorCode]: Email
    [emailMessageTypesBase.usernameForgot]: Email
    [emailMessageTypesBase.loginFromNewDevice]: Email
    [emailMessageTypesBase.specialist]: Email
    [emailMessageTypesBase.zohoTemplate]: Email
    [emailMessageTypesBase.specialistDiagnosisToCheck]: Email
    [emailMessageTypesBase.interpreterExamToCheck]: Email
  }
  [messageTypesBase.sms]: {
    [smsMessageTypesBase.usernameApp]: Sms
    [smsMessageTypesBase.forgotPasswordWithCode]: Sms
    [smsMessageTypesBase.createAppointment]: Sms
    [smsMessageTypesBase.testReady]: Sms
    [smsMessageTypesBase.criticalCaseNotAnswerd]: Sms
    [smsMessageTypesBase.noCallCenterDoctorsInShift]: Sms
    [smsMessageTypesBase.specialistDiagnosisToCheck]: Sms
    [smsMessageTypesBase.interpreterExamToCheck]: Sms
  }
}

export const languageEmpty = (): Translation => {
  return { [languagesBase.en]: null, [languagesBase.he]: null, [languagesBase.ru]: null }
}

export const emailEmpty = (): Email => {
  return {
    [emailObjectsBase.subject]: { ...languageEmpty() },
    [emailObjectsBase.body]: { ...languageEmpty() },
  }
}

export const smsEmpty = (): Sms => {
  return {
    [smsObjectsBase.message]: { ...languageEmpty() },
  }
}

export const emptyObj = (): ConfigurationMessage => {
  return {
    [messageTypesBase.email]: {
      [emailMessageTypesBase.passwordSetupSuccess]: { ...emailEmpty() },
      [emailMessageTypesBase.passwordForgot]: { ...emailEmpty() },
      [emailMessageTypesBase.passwordResetSuccess]: { ...emailEmpty() },
      [emailMessageTypesBase.registration]: { ...emailEmpty() },
      [emailMessageTypesBase.loginMultiFactorCode]: { ...emailEmpty() },
      [emailMessageTypesBase.usernameForgot]: { ...emailEmpty() },
      [emailMessageTypesBase.loginFromNewDevice]: { ...emailEmpty() },
      [emailMessageTypesBase.specialist]: { ...emailEmpty() },
      [emailMessageTypesBase.zohoTemplate]: { ...emailEmpty() },
      [emailMessageTypesBase.specialistDiagnosisToCheck]: { ...emailEmpty() },
      [emailMessageTypesBase.interpreterExamToCheck]: { ...emailEmpty() },
    },
    [messageTypesBase.sms]: {
      [smsMessageTypesBase.usernameApp]: { ...smsEmpty() },
      [smsMessageTypesBase.forgotPasswordWithCode]: { ...smsEmpty() },
      [smsMessageTypesBase.createAppointment]: { ...smsEmpty() },
      [smsMessageTypesBase.testReady]: { ...smsEmpty() },
      [smsMessageTypesBase.criticalCaseNotAnswerd]: { ...smsEmpty() },
      [smsMessageTypesBase.noCallCenterDoctorsInShift]: { ...smsEmpty() },
      [smsMessageTypesBase.specialistDiagnosisToCheck]: { ...smsEmpty() },
      [smsMessageTypesBase.interpreterExamToCheck]: { ...smsEmpty() },
    },
  }
}
